import { Box } from '@mui/material';
import { memo } from 'react';

interface IGridPointBoxProps {
  width: number;
  height: number;
}
function GridPointBox({ width, height }: IGridPointBoxProps): JSX.Element {
  return <Box sx={{ backgroundColor: 'mind.grid.pointBox', width, height, borderRadius: '7px' }} />;
}

export default memo(GridPointBox);
